module.exports = __webpack_public_path__ + "assets/img/20220802.96c5341d.png";